exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_listItem__20dF_{padding:1.25rem;font-size:.875rem!important}.style_emptyList__Jfq7l{padding:1.25rem}.style_loadMore__1k4D4{text-align:center}.style_pagingControlContainer__uFwzY{margin:1.5rem 1rem}.style_disablePagingEvents__NzHoU{pointer-events:none}", ""]);

// exports
exports.locals = {
	"listItem": "style_listItem__20dF_",
	"emptyList": "style_emptyList__Jfq7l",
	"loadMore": "style_loadMore__1k4D4",
	"pagingControlContainer": "style_pagingControlContainer__uFwzY",
	"disablePagingEvents": "style_disablePagingEvents__NzHoU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/PagingBaseComponent/style.less
// module id = 1645
// module chunks = 8